module.exports = __webpack_public_path__ + "static/media/f1eaa7278f64e27128e062a3de918265.c8b12c73.png";